import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";

export default function* watcherAddCreditPaymentSaga() {
    yield takeEvery("ADD_CREDIT_PAYMENT", workerSaga);
}

function* workerSaga(action) {
    try {
        var payload = {};
        yield put({ type: "DISPLAY_LOADER", payload: payload });

        var formatUrl = '/api/Admin/get-card-types'
        yield request("get", payload, formatUrl).then(response => {
            payload = response;
        });
        yield put({ type: "CARD_TYPE_DROPDOWN_LIST", payload: payload })

        formatUrl = "/api/Admin/get-accounts-dropdown";
        yield request("get", {}, formatUrl).then((response) => {
            payload = response;
        });
        yield put({ type: "ACCOUNT_DROPDOWN_LIST", payload: payload });

        formatUrl = `credit-payment`;
        yield request("post", action.payload, formatUrl).then((response) => {
            payload = response;
        });
        formatUrl = `get-credit-payment?transactionReference=${action.payload.tranRef}`;
        yield request("get", {}, formatUrl).then((response) => {
            payload = response;
        });
        yield put({ type: "CREDIT_PAYMENT", payload: payload });
        var formatUrl = "api/Admin/get-account-types";
        yield request("get", {}, formatUrl).then((response) => {
            payload = response;
        });
        yield put({ type: "ACCOUNT_TYPE_DROPDOWN_LIST", payload: payload });
        alert("Payment Recorded Successfully")
        yield put({ type: "DISPLAY_LOADER", payload: payload });
    } catch (e) {
        console.log(e);
        console.log("product-saga", e);
        console.log("product-saga", e.response);
        yield put({ type: "LOADING_BUTTON_SPINNER" });
        const errorMessage = getErrorMessage(e.response);
        toast.error(errorMessage);
        yield put({ type: "API_ERRORED", payload: e });
        yield put({ type: "DISPLAY_LOADER", payload: payload });
    }
}
